import styled from "styled-components"
import GridContainer from "@/components/common/GridContainer"
import Text from "@/components/common/Text"
import TeamMember from "@/components/TeamModule/TeamMember"
import { ScrollTrigger, useGSAP } from "@/utils/gsap"
import React, { useRef } from "react"
import { getCssSizeValue } from "@/utils/utils"
import { useIsMobile } from "@/hooks/useDevice"

const StyledWrapper = styled(GridContainer)`
	position: relative;
	padding: ${getCssSizeValue(80)} 0;

	.separator {
		position: absolute;
		background: ${(props) => props.theme.colors.slateGray};
		width: calc(100% + 2 * var(--paddingX));
		translate: calc(-1 * var(--paddingX));
		height: 1px;
	}
`

const StyledHeaderWrapper = styled.div``

export default function Section({ section, sectionIndex, handleSetModalData }) {
	const isMobile = useIsMobile()
	const header = section?.header || ""
	const items = section?.items || []

	const wrapperRef = useRef(null)
	const pinElementRef = useRef(null)

	useGSAP(
		() => {
			if (isMobile) return
			const { height } = pinElementRef.current.getBoundingClientRect()

			ScrollTrigger.create({
				trigger: ".pin-container",
				start: `top center`,
				end: `bottom-=${height} center`,
				pin: ".pin-element",
				pinSpacing: false,
				invalidateOnRefresh: true,
			})
		},
		{ scope: wrapperRef, dependencies: [isMobile] },
	)

	return (
		<StyledWrapper ref={wrapperRef}>
			<StyledHeaderWrapper className="col-desktop-4 col-mobile-8 pin-container">
				<div ref={pinElementRef} className="pin-element">
					<Text className="typo-borna typo-borna-07">{header}</Text>
				</div>
			</StyledHeaderWrapper>
			<div className="col-desktop-12 col-mobile-8">
				<GridContainer className="no-margin">
					{items.map((item, index) => {
						const id = item?.id || index
						return (
							<TeamMember
								key={id}
								memberIndex={index}
								sectionIndex={sectionIndex}
								member={item}
								handleSetModalData={handleSetModalData}
							/>
						)
					})}
				</GridContainer>
			</div>
			<div className="separator" />
		</StyledWrapper>
	)
}
